import React, {Component} from 'react';
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import parse from "html-react-parser";
import Slider from "react-slick";
import Fade from 'react-reveal/Fade'

const Awards = ({awards, content, title}) => {

  const settings = {
    className: "slider variable-width",
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  }

  return (
    <section className='awards'>
      <Fade bottom distance='30px'>
        <div className='awards__inner'>
          <div className='awards__content'>
            {title && <h3>{parse(title)}</h3>}
            {content && <div>{parse(content)}</div>}
          </div>
          <div className='awards__items'>
            <Slider {...settings}>
              {
                awards?.length > 0 && awards.map((el, i) => (
                  <div key={i} className='awards__item'>
                    <GatsbyImage loading='lazy' image={getImage(el.icon?.localFile)} alt={el.icon.altText}/>
                  </div>
                ))
              }
            </Slider>
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default Awards